"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Option_exports = {};
__export(Option_exports, {
  None: () => None,
  Option: () => Option,
  Some: () => Some,
  isOption: () => isOption
});
module.exports = __toCommonJS(Option_exports);
var import_Result = require("./Result.js");
class Some {
  constructor(value) {
    this.chain = (func) => {
      const b = func(this._value);
      if (b instanceof Some || b instanceof None) {
        return b;
      } else {
        return new Some(b);
      }
    };
    this.map = (func) => {
      return new Some(func(this._value));
    };
    this.nullMap = (func) => {
      const b = func(this._value);
      return b == null ? new None() : new Some(b);
    };
    this.flatMap = (func) => {
      return func(this._value);
    };
    this.tap = (func) => {
      return this.map((a) => {
        func(a);
        return a;
      });
    };
    this.filter = (func) => {
      return func(this._value) ? this : new None();
    };
    this.filterNot = (func) => {
      return func(this._value) ? new None() : this;
    };
    this.guard = (func) => {
      return func(this._value) ? Option.some(this._value) : Option.none();
    };
    this.fold = (_ifNone, ifSome) => {
      return ifSome(this._value);
    };
    this.forEach = (func) => {
      func(this._value);
    };
    this.isSome = () => {
      return true;
    };
    this.isNone = () => {
      return false;
    };
    this.toSuccess = (_error) => {
      return import_Result.Result.pure(this._value);
    };
    this.toFailure = (_value) => {
      return import_Result.Result.fail(this._value);
    };
    this.toArray = () => {
      return [this._value];
    };
    this.unsafeGet = () => {
      return this._value;
    };
    this.orElse = (_func) => {
      return this;
    };
    this.orElseNullable = (_func) => {
      return this;
    };
    this.getOrElse = (_func) => {
      return this._value;
    };
    this.getOrThrow = (_error) => {
      return this._value;
    };
    this.getOrNull = () => {
      return this._value;
    };
    this.getOrUndefined = () => {
      return this._value;
    };
    this._value = value;
  }
}
class None {
  constructor() {
    this.chain = (_func) => {
      return new None();
    };
    this.map = (_func) => {
      return new None();
    };
    this.nullMap = (_func) => {
      return new None();
    };
    this.flatMap = (_func) => {
      return new None();
    };
    this.tap = (_func) => {
      return this;
    };
    this.filter = (_func) => {
      return this;
    };
    this.filterNot = (_func) => {
      return this;
    };
    this.guard = (_func) => {
      return Option.none();
    };
    this.fold = (ifNone, _ifSome) => {
      return ifNone();
    };
    this.forEach = (_func) => {
      return;
    };
    this.isSome = () => {
      return false;
    };
    this.isNone = () => {
      return true;
    };
    this.toSuccess = (error) => {
      return import_Result.Result.fail(error());
    };
    this.toFailure = (value) => {
      return import_Result.Result.pure(value());
    };
    this.toArray = () => {
      return [];
    };
    this.unsafeGet = () => {
      throw new Error("Called unsafeGet on a None");
    };
    this.orElse = (func) => {
      return func();
    };
    this.orElseNullable = (func) => {
      return Option.wrap(func());
    };
    this.getOrElse = (func) => {
      return func();
    };
    this.getOrThrow = (error) => {
      throw error();
    };
    this.getOrNull = () => {
      return null;
    };
    this.getOrUndefined = () => {
      return void 0;
    };
  }
}
function some(value) {
  return new Some(value);
}
const _none = new None();
function none() {
  return _none;
}
function wrap(value) {
  return value == null ? new None() : new Some(value);
}
function cond(cond2) {
  return function(value) {
    return cond2 ? Option.some(value()) : Option.none();
  };
}
function tupled(opts) {
  const values = [];
  for (const opt of opts) {
    if (opt instanceof Some) {
      values.push(opt._value);
    } else {
      return none();
    }
  }
  return some(values);
}
function when(...opts) {
  const option = tupled(opts);
  return (func) => option.map((values) => func(...values));
}
function sequence(options) {
  const ans = [];
  for (const opt of options) {
    if (opt instanceof Some) {
      ans.push(opt._value);
    } else if (opt instanceof None) {
      return none();
    } else {
      throw new Error("Unknown Option type: " + opt);
    }
  }
  return some(ans);
}
function traverse(as) {
  return function(func) {
    const ans = [];
    for (const a of as) {
      const opt = func(a);
      if (opt instanceof Some) {
        ans.push(opt._value);
      } else if (opt instanceof None) {
        return none();
      } else {
        throw new Error("Unknown Option type: " + opt);
      }
    }
    return some(ans);
  };
}
const Option = {
  some,
  none,
  wrap,
  cond,
  when,
  tupled,
  sequence,
  traverse
};
function isOption(isA) {
  return function(value) {
    if (value instanceof Some) {
      return isA(value._value);
    } else if (value instanceof None) {
      return true;
    } else {
      return false;
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  None,
  Option,
  Some,
  isOption
});
//# sourceMappingURL=Option.js.map
